import { Card, Typography } from 'antd'
import { FC } from 'react'
import styled from 'styled-components'
import type { MetricTone } from '../helpers/calc-printer-monthly-stats'

const CardStyled = styled(Card)`
    width: 100%;

    & .ant-card-body {
        padding: 12px 16px;
    }
`

const Label = styled(Typography.Text)`
    display: block;
    margin-bottom: 4px;
    font-size: 12px;
`

interface SummaryStatCardProps {
    label: string
    value?: string | number | null
    tone?: MetricTone | null
    details?: string[]
}

const Detail = styled(Typography.Text)`
    display: block;
    margin-top: 4px;
    font-size: 12px;
`

const SummaryStatCard: FC<SummaryStatCardProps> = ({ label, value, tone, details }) => {
    const displayValue = value == null || value === '' ? '—' : value

    return (
        <CardStyled size='small'>
            <Label type='secondary'>{label}</Label>
            <Typography.Text strong type={tone ?? undefined}>
                {displayValue}
            </Typography.Text>
            {details?.map(detail => (
                <Detail key={detail} type='secondary'>
                    {detail}
                </Detail>
            ))}
        </CardStyled>
    )
}

export default SummaryStatCard
